module.exports = __webpack_public_path__ + "static/img/best_supporting_actress_video_01.476272a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/best_supporting_actress_video_01.jpg
// module id = 113
// module chunks = 0